import Error from './error.js';
import ManageArea from '../component/manage/content.js';
import ManageUser from '../component/manage/user.js';
import ManageAreaPass from '../component/manage/pass.js';
import Internet from '../component/internet/content.js';
import School from '../component/school/content.js';
import Add from '../component/school/add.js';
import Builder from '../component/builder/content.js';
import AddBuilder from '../component/builder/add.js';
// import Power from '../component/power/content.js';
import PowerAdd from '../component/power/add.js';
import Record from '../component/record/content.js';
import RecordExport from '../component/record/export.js';
import Login from './login.js';
import CodeLogin from './codelogin.js';
import Sub from '../component/sub/content.js';
import AddSub from '../component/sub/add.js';
import DeviceAlarm from '../component/devicealarm/content.js';
import AlarmRecord from '../component/devicealarm/alarmrecord.js';
import AlarmRule from '../component/devicealarm/alarmrule.js';
import AlarmContacts from '../component/devicealarm/alarmcontacts.js';

const menuList = {
  default : "/login",
  list : [{
    title : "门禁用户",
    key : "/manage/user",
    icon : 'page-sub',
    content : ManageUser,
    hide : false,
    authority : ["ADMIN"],
  }, {
    title : "门禁区域",
    key : "/manage/area",
    icon : 'page-search',
    content : ManageArea,
    hide : false,
    authority : ["ADMIN"],
    sub : [{
      title : "查看可通行人员",
      key : "/manage/area/pass",
      icon : 'page-search',
      content : ManageAreaPass,
      hide : true
    }]
  }, {
    title : "联网状态",
    key : "/internet",
    icon : 'page-product',
    content : Internet,
    hide : true,
    authority : ["ADMIN", "SUPER"],
  }, {
    title : "学校管理",
    key : "/school",
    icon : 'page-school',
    content : School,
    hide : false,
    authority : ["SUPER"],
    sub : [{
      title : "添加学校",
      key : "/school/add",
      content : Add,
      hide : true
    }],
  }, {
    title : "权限操作",
    key : "/power/add",
    icon : 'page-type',
    content : PowerAdd,
    hide : false,
    authority : ["ADMIN", "SUBADMIN"],
  }, {
    title : "开门记录",
    key : "/record",
    icon : 'page-product',
    content : Record,
    hide : false,
    authority : ["ADMIN", "SUBADMIN"],
    sub : [{
      title : "导出记录",
      key : "/record/export",
      content : RecordExport,
      hide : true
    }]
  }, {
    title : "施工人员管理",
    key : "/builder",
    icon : 'page-account',
    content : Builder,
    hide : false,
    authority : ["ADMIN"],
    sub : [{
      title : "添加施工人员",
      key : "/builder/add",
      content : AddBuilder,
      hide : true
    }],
  }, {
    title : "子管理员管理",
    key : "/sub",
    icon : 'page-account',
    content : Sub,
    hide : false,
    authority : ["ADMIN"],
    sub : [{
      title : "添加管理员",
      key : "/sub/add",
      content : AddSub,
      hide : true
    }],
  }, {
    title : "设备报警",
    key : "/devicealarm",
    icon : 'bell',
    content : DeviceAlarm,
    hide : false,
    authority : ["ADMIN"],
    sub : [{
      title : "报警记录",
      key : "/devicealarm/alarmrecord",
      content : AlarmRecord,
      hide : false
    }, {
      title : "报警规则",
      key : "/devicealarm/alarmrule",
      content : AlarmRule,
      hide : false
    }, {
      title : "报警联系人",
      key : "/devicealarm/alarmcontacts",
      content : AlarmContacts,
      hide : false
    }],
  }, {
    key : "/login",
    content : Login,
    hide : true,
    authority : ["ADMIN","SUBADMIN","SUPER"],
  }, {
    key: "/super",
    content: CodeLogin,
    hide: true,
    authority : ["ADMIN","SUBADMIN","SUPER"],
  },{
    key : "/404",
    content: Error,
    hide : true,
  }, {
    key : "/403",
    content: Error,
    hide : true,
  },{
    key : "/500",
    content: Error,
    hide : true,
  }
]};
export default menuList;



// WEBPACK FOOTER //
// ./src/index/menulist.js